if (!window.__fhrScriptsLoaded) {
  window.__fhrScriptsLoaded = true;
  document.addEventListener('DOMContentLoaded', function () {
  initFhrReveals();
  initFhrCounters();
  initFhrContactModal();
  initFhrLogoBadge();
  initFhrCarousels();
  initFhrSlideshows();
  initFhrScrollBg();
  initFhrAiChat();
});
}

function initFhrReveals() {
  var els = document.querySelectorAll('.fhr-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('fhr-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('fhr-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initFhrCounters() {
  var counters = document.querySelectorAll('[data-fhr-counter]');
  if (!counters.length) return;
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var target = parseInt(el.getAttribute('data-fhr-counter'), 10) || 0;
      var duration = 1200;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        el.textContent = Math.floor(progress * target);
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target;
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  counters.forEach(function (el) { observer.observe(el); });
}

function initFhrContactModal() {
  var modal = document.getElementById('fhr-contact-modal');
  if (!modal) return;

  var openers = document.querySelectorAll('[data-fhr-contact-trigger]');
  var closers = modal.querySelectorAll('[data-fhr-contact-close]');
  var lastFocused = null;

  function openModal(e) {
    if (e) e.preventDefault();
    lastFocused = document.activeElement;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fhr-modal-open');
    var closeBtn = modal.querySelector('.fhr-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fhr-modal-open');
    if (lastFocused) lastFocused.focus();
  }

  openers.forEach(function (el) {
    el.addEventListener('click', openModal);
  });
  closers.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });
}

function initFhrLogoBadge() {
  var badge = document.querySelector('[data-fhr-logo-badge]');
  if (!badge) return;

  // Some themes (Horizon included) scroll an inner wrapper instead of the
  // window itself (html/body get overflow: hidden). Detect that wrapper so
  // the badge reacts to the scroll position visitors actually see.
  var scroller = document.querySelector('.page-wrapper');
  var useWindow = !scroller || scroller.scrollHeight <= scroller.clientHeight;
  if (useWindow) scroller = document.scrollingElement || document.documentElement;

  var ticking = false;

  function update() {
    ticking = false;
    var scrollTop = useWindow ? (window.scrollY || window.pageYOffset) : scroller.scrollTop;
    var viewportH = useWindow ? window.innerHeight : scroller.clientHeight;
    var scrollH = useWindow ? document.documentElement.scrollHeight : scroller.scrollHeight;
    var showStart = viewportH * 0.7;
    var showEnd = scrollH - viewportH - 400;
    var visible = scrollTop > showStart && scrollTop < showEnd;
    badge.classList.toggle('is-visible', visible);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  var scrollTarget = useWindow ? window : scroller;
  scrollTarget.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
}

function initFhrCarousels() {
  var tracks = document.querySelectorAll('[data-fhr-carousel]');
  tracks.forEach(function (track) {
    var wrap = track.closest('.fhr-section') || track.parentElement;
    var prev = wrap.querySelector('[data-fhr-carousel-prev]');
    var next = wrap.querySelector('[data-fhr-carousel-next]');
    if (!prev && !next) return;

    function step() {
      var card = track.querySelector(':scope > *');
      if (!card) return track.clientWidth * 0.8;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || '16') || 16;
      return card.getBoundingClientRect().width + gap;
    }

    if (prev) prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
  });
}

function initFhrSlideshows() {
  var shows = document.querySelectorAll('[data-fhr-slideshow]');
  if (!shows.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  shows.forEach(function (show) {
    var slides = show.querySelectorAll('.fhr-shopby__slide, .fhr-builds__slide');
    if (slides.length < 2) return;
    var interval = parseInt(show.getAttribute('data-interval'), 10) || 2000;
    var i = 0;
    setInterval(function () {
      if (document.hidden) return;
      slides[i].setAttribute('data-active', 'false');
      i = (i + 1) % slides.length;
      slides[i].setAttribute('data-active', 'true');
    }, interval);
  });
}

function initFhrScrollBg() {
  var root = document.querySelector('[data-fhr-scroll-bg]');
  if (!root) return;
  var files = (root.getAttribute('data-files') || '').split(',').filter(Boolean);
  var holder = root.querySelector('[data-fhr-scroll-bg-videos]');
  var secPerScreen = parseFloat(root.getAttribute('data-seconds-per-screen')) || 3;
  var fitPage = root.getAttribute('data-fit-page') === 'true';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 900px) and (pointer: fine)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var mode = root.getAttribute('data-mode') || 'loop';
  var speed = (parseFloat(root.getAttribute('data-speed')) || 100) / 100;
  // Reduced motion and data-saver keep the still image (no download).
  if (!files.length || reduce || saveData) return;

  if (mode === 'loop') {
    var lv = document.createElement('video');
    lv.muted = true; lv.defaultMuted = true; lv.loop = true; lv.autoplay = true; lv.playsInline = true;
    lv.setAttribute('muted', ''); lv.setAttribute('playsinline', ''); lv.preload = 'auto'; lv.tabIndex = -1;
    lv.addEventListener('loadeddata', function () {
      lv.playbackRate = speed;
      var pr = lv.play();
      if (pr && pr.catch) pr.catch(function () {});
      lv.classList.add('is-active');
      root.classList.add('is-ready');
    });
    lv.addEventListener('error', function () { if (holder) holder.innerHTML = ''; });
    lv.src = files[0];
    holder.appendChild(lv);
    return;
  }

  // Scroll-scrub mode is desktop only (heavy all-keyframe file).
  if (!desktop) return;

  var scroller = document.querySelector('.page-wrapper');
  var useWindow = !scroller || scroller.scrollHeight <= scroller.clientHeight;
  var scrollTarget = useWindow ? window : scroller;
  function scrollPos() { return useWindow ? (window.scrollY || window.pageYOffset) : scroller.scrollTop; }
  function viewH() { return useWindow ? window.innerHeight : scroller.clientHeight; }

  var vids = [];
  var durations = [];
  var loaded = 0;
  var failed = false;

  files.forEach(function (src, i) {
    var v = document.createElement('video');
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.preload = 'auto';
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.tabIndex = -1;
    v.addEventListener('loadedmetadata', function () {
      durations[i] = v.duration;
      loaded++;
      if (loaded === files.length && !failed) begin();
    });
    v.addEventListener('error', function () {
      failed = true;
      if (holder) holder.innerHTML = '';
    });
    v.src = src;
    holder.appendChild(v);
    vids.push(v);
  });

  var total = 0;
  var cur = 0;
  var target = 0;
  var running = false;
  var activeIdx = -1;

  function setActive(i) {
    if (i === activeIdx) return;
    activeIdx = i;
    vids.forEach(function (v, k) { v.classList.toggle('is-active', k === i); });
  }

  function seek(v, t) {
    if (v.seeking) return;
    if (Math.abs(v.currentTime - t) > 0.012) v.currentTime = t;
  }

  function frame() {
    if (fitPage) {
      var pageH = useWindow ? document.documentElement.scrollHeight : scroller.scrollHeight;
      target = (scrollPos() / Math.max(pageH - viewH(), 1)) * total;
    } else {
      target = (scrollPos() / Math.max(viewH(), 1)) * secPerScreen;
    }
    cur += (target - cur) * 0.14;
    var done = Math.abs(target - cur) < 0.003;
    if (done) cur = target;

    var t = ((cur % total) + total) % total;
    var seg = 0, acc = 0;
    while (seg < vids.length - 1 && t >= acc + durations[seg]) { acc += durations[seg]; seg++; }
    var local = Math.min(t - acc, durations[seg] - 0.05);

    setActive(seg);
    seek(vids[seg], local);

    if (vids.length > 1) {
      var next = (seg + 1) % vids.length;
      var prev = (seg - 1 + vids.length) % vids.length;
      if (local > durations[seg] - 1.2) seek(vids[next], 0);
      if (local < 1.2) seek(vids[prev], Math.max(durations[prev] - 0.05, 0));
    }

    if (done) { running = false; return; }
    requestAnimationFrame(frame);
  }

  function kick() {
    if (running) return;
    running = true;
    requestAnimationFrame(frame);
  }

  function begin() {
    durations.forEach(function (d) { total += d; });
    if (!total) return;
    setActive(0);
    root.classList.add('is-ready');
    scrollTarget.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
    kick();
  }
}

function fhrAiFormat(text) {
  var out = String(text || '')
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  out = out.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
  out = out.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (m, label, url) {
    var safe = url.replace(/"/g, '%22');
    var ok = /^\//.test(safe) || /^https?:\/\//i.test(safe) || /^tel:/i.test(safe) || /^mailto:/i.test(safe);
    if (!ok) return label;
    var external = /^https?:\/\//i.test(safe) && safe.indexOf(location.host) === -1;
    return '<a href="' + safe + '"' + (external ? ' target="_blank" rel="noopener"' : '') + '>' + label + '</a>';
  });
  out = out.replace(/^\s*[-*]\s+/gm, '• ');
  return out.replace(/\n/g, '<br>');
}

function initFhrAiChat() {
  var root = document.querySelector('[data-fhr-ai]');
  if (!root) return;
  var endpoint = root.getAttribute('data-endpoint');
  if (!endpoint) return;

  var panel = root.querySelector('[data-fhr-ai-panel]');
  var log = root.querySelector('[data-fhr-ai-log]');
  var form = root.querySelector('[data-fhr-ai-form]');
  var input = form.querySelector('input');
  var sendBtn = form.querySelector('button[type="submit"]');
  var openBtn = root.querySelector('[data-fhr-ai-open]');
  var closeBtn = root.querySelector('[data-fhr-ai-close]');
  var bubble = root.querySelector('[data-fhr-ai-bubble]');
  var chips = root.querySelector('[data-fhr-ai-chips]');
  var greeting = root.getAttribute('data-greeting') || '';
  var phone = root.getAttribute('data-fallback-phone') || '';
  var history = [];
  var busy = false;

  var catalog = [];
  try {
    var cat = root.querySelector('[data-fhr-ai-catalog]');
    if (cat) catalog = JSON.parse(cat.textContent || '[]');
  } catch (e) { catalog = []; }

  function store(key, val) { try { if (val === undefined) return sessionStorage.getItem(key); sessionStorage.setItem(key, val); } catch (e) {} return null; }

  function addMsg(role, text) {
    var el = document.createElement('div');
    el.className = 'fhr-ai__msg fhr-ai__msg--' + (role === 'user' ? 'user' : 'bot');
    el.innerHTML = fhrAiFormat(text);
    log.appendChild(el);
    log.scrollTop = log.scrollHeight;
    return el;
  }

  function persist() { store('fhr_ai_history', JSON.stringify(history.slice(-20))); }

  function restore() {
    var saved = null;
    try { saved = JSON.parse(store('fhr_ai_history') || 'null'); } catch (e) {}
    if (saved && saved.length) {
      history = saved;
      history.forEach(function (m) { addMsg(m.role, m.text); });
      chips.hidden = true;
    } else if (greeting) {
      addMsg('model', greeting);
    }
  }

  function openPanel() {
    panel.hidden = false;
    openBtn.setAttribute('aria-expanded', 'true');
    if (bubble) bubble.hidden = true;
    store('fhr_ai_bubble_done', '1');
    log.scrollTop = log.scrollHeight;
    setTimeout(function () { input.focus(); }, 60);
  }
  function closePanel() {
    panel.hidden = true;
    openBtn.setAttribute('aria-expanded', 'false');
  }

  async function ask(question) {
    if (busy || !question) return;
    busy = true;
    sendBtn.disabled = true;
    chips.hidden = true;
    addMsg('user', question);
    history.push({ role: 'user', text: question });
    var typing = document.createElement('div');
    typing.className = 'fhr-ai__msg fhr-ai__msg--bot';
    typing.innerHTML = '<span class="fhr-ai__typing"><i></i><i></i><i></i></span>';
    log.appendChild(typing);
    log.scrollTop = log.scrollHeight;

    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, 30000);
    try {
      var res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          messages: history.slice(-10),
          page: { path: location.pathname, title: document.title },
          catalog: catalog
        }),
        signal: ctrl.signal
      });
      var data = await res.json().catch(function () { return {}; });
      if (!res.ok || !data.reply) throw new Error(data.error || 'bad response');
      typing.remove();
      addMsg('model', data.reply);
      history.push({ role: 'model', text: data.reply });
    } catch (err) {
      typing.remove();
      var msg = "Sorry, I'm having trouble answering right now." + (phone ? ' Please call the shop at ' + phone + ' and we will help you right away.' : ' Please use the contact button and we will help you right away.');
      addMsg('model', msg);
      history.pop();
    } finally {
      clearTimeout(timer);
      busy = false;
      sendBtn.disabled = false;
      persist();
      input.focus();
    }
  }

  openBtn.addEventListener('click', function () { panel.hidden ? openPanel() : closePanel(); });
  closeBtn.addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) closePanel(); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim();
    if (!q) return;
    input.value = '';
    ask(q);
  });
  root.querySelectorAll('[data-fhr-ai-chip]').forEach(function (chip) {
    chip.addEventListener('click', function () { ask(chip.textContent.trim()); });
  });

  if (bubble) {
    var bclose = bubble.querySelector('[data-fhr-ai-bubble-close]');
    if (bclose) bclose.addEventListener('click', function () { bubble.hidden = true; store('fhr_ai_bubble_done', '1'); });
    if (!store('fhr_ai_bubble_done')) {
      setTimeout(function () { if (panel.hidden) bubble.hidden = false; }, 3500);
      setTimeout(function () { bubble.hidden = true; }, 18000);
    }
  }

  restore();
}
